export const _permissions_all = [
    { "provider": "pragmatic", "middleware": "matgame" },
    { "provider": "evoplay", "middleware": "matgame" },
    { "provider": "novomatic", "middleware": "matgame" },
    { "provider": "kagaming", "middleware": "matgame" },
    { "provider": "playson", "middleware": "matgame" },
    { "provider": "bigpot", "middleware": "matgame" },
    { "provider": "pgsoft", "middleware": "matgame" },
    { "provider": "merkur", "middleware": "matgame" },
    { "provider": "egt", "middleware": "matgame" },
    { "provider": "habanero", "middleware": "matgame" },
    { "provider": "netent", "middleware": "matgame" },
    { "provider": "aviatrix", "middleware": "matgame" },
    { "provider": "sexygaming", "middleware": "matgame" },
    { "provider": "spadegaming", "middleware": "matgame" },
    { "provider": "n2", "middleware": "matgame" },
    { "provider": "igt", "middleware": "matgame" },
    { "provider": "apollo", "middleware": "matgame" },
    { "provider": "wmcasino", "middleware": "matgame" },
    { "provider": "booongo", "middleware": "matgame" },
    { "provider": "rich88", "middleware": "matgame" },
    { "provider": "live22", "middleware": "matgame" },
    { "provider": "ailivecasino", "middleware": "matgame" },
    { "provider": "dreamgaming", "middleware": "matgame" },
    { "provider": "ezugi", "middleware": "matgame" },
    { "provider": "spribe", "middleware": "matgame" },
    { "provider": "voltentertainment", "middleware": "matgame" },
    { "provider": "mrslotty", "middleware": "matgame" },
    { "provider": "jili", "middleware": "matgame" },
    { "provider": "toptrendgaming", "middleware": "matgame" },
    { "provider": "evolution", "middleware": "matgame" },
    { "provider": "reelkingdom", "middleware": "matgame" },
    { "provider": "goldenrace", "middleware": "matgame" },
    { "provider": "wmg", "middleware": "matgame" },
    { "provider": "kajot", "middleware": "matgame" },
    { "provider": "microgaming", "middleware": "matgame" },
    { "provider": "quickspin", "middleware": "matgame" },
    { "provider": "worldentertainment", "middleware": "matgame" },
    { "provider": "gaminator", "middleware": "matgame" },
    { "provider": "jetx", "middleware": "matgame" },
    { "provider": "btg", "middleware": "matgame" },
    { "provider": "vivo", "middleware": "matgame" },
    { "provider": "cq9", "middleware": "matgame" },
    { "provider": "konami", "middleware": "matgame" },
    { "provider": "spaceman", "middleware": "matgame" },
    { "provider": "portomaso", "middleware": "matgame" },
    { "provider": "fachai", "middleware": "matgame" },
    { "provider": "boominggames", "middleware": "matgame" },
    { "provider": "fatpanda", "middleware": "matgame" },
    { "provider": "epicwin", "middleware": "matgame" },
    { "provider": "clawbuster", "middleware": "innova" },
    { "provider": "gamebeat", "middleware": "innova" },
    { "provider": "macaw", "middleware": "innova" },
    { "provider": "yoriginal-games", "middleware": "innova" },
    { "provider": "phoenix7", "middleware": "innova" },
    { "provider": "booming", "middleware": "innova" },
    { "provider": "abracadabra", "middleware": "innova" },
    { "provider": "beon", "middleware": "innova" },
    { "provider": "adlunam", "middleware": "innova" },
    { "provider": "bitblox", "middleware": "innova" },
    { "provider": "ezugiX", "middleware": "innova" },
    { "provider": "ezugiZ", "middleware": "innova" },
    { "provider": "eagaming", "middleware": "innova" },
    { "provider": "onegame", "middleware": "innova" },
    { "provider": "galaxsys", "middleware": "innova" },
    { "provider": "betsoft-a", "middleware": "innova" },
    { "provider": "elagames-a", "middleware": "innova" },
    { "provider": "in-out", "middleware": "innova" },
    { "provider": "7777", "middleware": "innova" },
    { "provider": "rocketman", "middleware": "innova" },
    { "provider": "pigaboom", "middleware": "innova" },
    { "provider": "netgame", "middleware": "innova" },
    { "provider": "pateplay", "middleware": "innova" },
    { "provider": "formulaspin", "middleware": "innova" },
    { "provider": "prospectgaming", "middleware": "innova" },
    { "provider": "iconix", "middleware": "innova" },
    { "provider": "irondogP", "middleware": "innova" },
    { "provider": "irondogPP", "middleware": "innova" },
    { "provider": "airdice", "middleware": "innova" },
    { "provider": "armadillostudios", "middleware": "innova" },
    { "provider": "tada", "middleware": "innova" },
    { "provider": "sagaming", "middleware": "innova" },
    { "provider": "fazi", "middleware": "innova" },
    { "provider": "eezecasino", "middleware": "innova" },
    { "provider": "barbara-bang", "middleware": "innova" },
    { "provider": "bitville", "middleware": "innova" },
    { "provider": "1x2gaming", "middleware": "innova" },
    { "provider": "aviator", "middleware": "innova" },
    { "provider": "bgamingP", "middleware": "innova" },
    { "provider": "rubyplay", "middleware": "innova" },
    { "provider": "pateplay-live", "middleware": "innova" },
    { "provider": "vision-b", "middleware": "innova" },
    { "provider": "creedroomz", "middleware": "innova" },
    { "provider": "eclipse-b", "middleware": "innova" },
    { "provider": "creedroomzP", "middleware": "innova" },
    { "provider": "jvl", "middleware": "innova" },
    { "provider": "visionP", "middleware": "innova" },
    { "provider": "irondogP", "middleware": "innova" },
    { "provider": "redstone", "middleware": "innova" },
    { "provider": "pascalgaming", "middleware": "innova" },
    { "provider": "only-play", "middleware": "innova" },
    { "provider": "100hp", "middleware": "innova" },
    { "provider": "vivo", "middleware": "innova" },
    { "provider": "ftv", "middleware": "innova" },
    { "provider": "amusnet-live", "middleware": "innova" },
    { "provider": "pragmatic-bj2", "middleware": "innova" },
    { "provider": "pragmatic-live", "middleware": "innova" },
    { "provider": "pragmaticS", "middleware": "innova" },
    { "provider": "bwgaming", "middleware": "innova" },
    { "provider": "bgaming", "middleware": "innova" },
    { "provider": "evolutionGHX", "middleware": "innova" },
    { "provider": "dreamplay", "middleware": "innova" },
    { "provider": "evolutionGHLS", "middleware": "innova" },
    { "provider": "yggdrasil-a", "middleware": "innova" },
    { "provider": "skywind-bj", "middleware": "innova" },
    { "provider": "ezugi", "middleware": "innova" },
    { "provider": "eclipse", "middleware": "innova" },
    { "provider": "absolute", "middleware": "innova" },
    { "provider": "7-mojos-slots", "middleware": "innova" },
    { "provider": "ftvP", "middleware": "innova" },
    { "provider": "7-mojos", "middleware": "innova" },
    { "provider": "religa", "middleware": "innova" },
    { "provider": "netent-gh", "middleware": "innova" },
    { "provider": "apparat", "middleware": "innova" },
    { "provider": "bwgaming", "middleware": "innova" },
    { "provider": "popok-live", "middleware": "innova" },
    { "provider": "bfgamesB", "middleware": "innova" },
    { "provider": "amusnet-live", "middleware": "innova" },
    { "provider": "redstone", "middleware": "innova" },
    { "provider": "bullshark", "middleware": "innova" },
    { "provider": "mancala", "middleware": "innova" },
    { "provider": "goldenrace", "middleware": "innova" },
    { "provider": "jetx", "middleware": "innova" },
    { "provider": "liw", "middleware": "innova" },
    { "provider": "tvbet", "middleware": "innova" },
    { "provider": "fils", "middleware": "innova" },
    { "provider": "spinomenal", "middleware": "innova" },
    { "provider": "amusnet", "middleware": "innova" },
    { "provider": "hacksaw", "middleware": "innova" },
    { "provider": "flipluck", "middleware": "innova" },
    { "provider": "redtiger-gh", "middleware": "innova" },
    { "provider": "pgsoft", "middleware": "innova" },
    { "provider": "evolutionGHLS", "middleware": "innova" },
    { "provider": "platipus", "middleware": "innova" },
    { "provider": "evolutionGHHS", "middleware": "innova" },
    { "provider": "evolutionGHY", "middleware": "innova" },
    { "provider": "pragmatic-bj2", "middleware": "innova" },
    { "provider": "pragmatic", "middleware": "innova" },
    { "provider": "spearheadP", "middleware": "innova" },
    { "provider": "habanero", "middleware": "innova" },
    { "provider": "skywind-live", "middleware": "innova" },
    { "provider": "skywind", "middleware": "innova" },
    { "provider": "micro-gaming", "middleware": "innova" },
    { "provider": "intouch-games", "middleware": "innova" },
    { "provider": "bigtimegaming-gh", "middleware": "innova" },
    { "provider": "iconic21-slots", "middleware": "innova" },
    { "provider": "irondog", "middleware": "innova" },
    { "provider": "caletagaming", "middleware": "innova" },
    { "provider": "nolimitcity-gh", "middleware": "innova" },
    { "provider": "ctinteractive", "middleware": "innova" },
    { "provider": "redrake", "middleware": "innova" },
    { "provider": "imagineliveLS", "middleware": "innova" },
    { "provider": "altente", "middleware": "innova" },
    { "provider": "3oaks", "middleware": "innova" },
    { "provider": "wazdan-a", "middleware": "innova" },
    { "provider": "evolutionGH", "middleware": "innova" },
    { "provider": "novo-matic", "middleware": "innova" },
    { "provider": "popok", "middleware": "innova" },
    { "provider": "play-son", "middleware": "innova" },
    { "provider": "bfgames", "middleware": "innova" },
    { "provider": "platipus-live", "middleware": "innova" },
    { "provider": "creedroomz-b", "middleware": "innova" },
    { "provider": "visionP", "middleware": "innova" },
    { "provider": "smartsoft", "middleware": "innova" },
    { "provider": "backseat", "middleware": "innova" },
    { "provider": "onetouch", "middleware": "innova" },
    { "provider": "spearhead", "middleware": "innova" },
    { "provider": "retrogames", "middleware": "innova" },
    { "provider": "onetouch-live", "middleware": "innova" },
    { "provider": "micro-gaming-live", "middleware": "innova" },
    { "provider": "platingaming", "middleware": "innova" },
    { "provider": "gamzix", "middleware": "innova" },
    { "provider": "imagine live", "middleware": "innova" },
    { "provider": "3oaksP", "middleware": "innova" },
    { "provider": "pragmatic-bj", "middleware": "innova" },
    { "provider": "evolutionGHX", "middleware": "innova" },
    { "provider": "aviatrix", "middleware": "innova" },
    { "provider": "turbo-games", "middleware": "innova" },
    { "provider": "imagineliveHS", "middleware": "innova" },
    { "provider": "pascalgaming", "middleware": "innova" },
    { "provider": "endorphina", "middleware": "innova" },
    { "provider": "play-sonP", "middleware": "innova" },
    { "provider": "pragmatic-virtual", "middleware": "innova" },
    { "provider": "onetouch-bj", "middleware": "innova" },
    { "provider": "popiplay", "middleware": "innova" },
    { "provider": "vivo", "middleware": "innova" },
    { "provider": "galaxsysP", "middleware": "innova" },
    { "provider": "ftv-b", "middleware": "innova" },
    { "provider": "eclipseP", "middleware": "innova" },
    { "provider": "bgaming", "middleware": "innova" },
    { "provider": "iconic21", "middleware": "innova" },
    { "provider": "pixmove-games", "middleware": "innova" }
]